<app-menu-common url="sales"></app-menu-common>

<div class="pagecontent header">
  <div class="flexrow header">
    <div class="pagetitle grey" >Tableau des virements</div>
    <div class=""><button mat-flat-button color="secondary" type="button" aria-label="Extraire Lots" (click)=onClickExport()>Export Comptable</button></div>
  </div>
  <div class="table-container">
    @if (virements.length > 0) {
      <table>
        <thead>
          <tr>
            <th>Date<br>Comptable</th>
            <th>Organisme<br>Payeur</th>
            <th>Libellé<br>Virement</th>
            <th>Montant</th>
            <th>Paiement<br>Ponctuel ?</th>
          </tr>
        </thead>
        <tbody>
          @for (v of virements; track v) {
            <!-- <td>{{ rsp.id }}</td> -->
            <tr (click)="toggleVirement(v)" class="clickable-row" [class.active]="selectedVirement === v">
              <td>{{ v.dateComptable  | date:'dd/MM/yy' }}</td>
              <td>{{ v.numEmetFic }}</td>
              <td class="lib-column">
                @if (v.libVirementLines.length === 0) {
                  <span class="text-muted">-</span>
                }
                @for (line of v.libVirementLines; track line; let first = $first) {
                  <div
                    [class.sub-line]="!first">
                    {{ line }}
                  </div>
                }
              </td>
              <td class="text-right font-mono">
                {{ v.montant / 100 | number:'1.2-2':'fr-FR' }} €
              </td>
              <td style="text-align: center;">
                @if (v.isPonctuel) {
                  <span title="Paiement ponctuel" style="font-size: 1.2rem; vertical-align: middle;">✅</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }


    @if (selectedVirement) {
      <div class="side-panel-backdrop" (click)="closePanel()"></div>
    }

    <div class="side-panel" [class.open]="selectedVirement">
      @if (selectedVirement) {
        <div class="side-panel-content">
          <button class="close-btn" (click)="closePanel()">&times;</button>
          <div class="rsp-detail-wrapper">
            <div class="rsp-header">
              Détails des mouvements
              <span class="rsp-badge">{{ selectedVirement.rsps.length }}</span>
            </div>
            @for (rsp of selectedVirement.rsps; track rsp) {
              <div class="flexcolumn">
                <app-detail-rsp [rsp]="rsp"></app-detail-rsp>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>